export const EXERCISE_VIDEO_BASE_PATH =
  'https://storage.googleapis.com/golfdr-motion-core-exercises/exercises';
export const EXERCISE_THUMBNAIL_BASE_PATH =
  '//storage.googleapis.com/golfdr-motion-core-exercises/exercises/thumbnails';
export const EXERCISE_THUMBNAIL_EXTENSION = 'jpg';
